// extracted by mini-css-extract-plugin
export var dividerContainer = "_7e-0";
export var line = "_7e-1";